import * as _ from "lodash";
import { cloneDeep } from "lodash";

import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { ENGAGEMENT_UNIQUE_USERS } from "app/constants/metrics";
import { V2_ROUTES } from "app/pages/industry-analysis/routes/routes";
import { ECategoryAudienceType } from "app/pages/website-analysis/website-structure/pages/AudienceWrapper";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { DefaultCellRightAlign } from "../../../React/Table/cells/DefaultCellRightAlign";

const getDashboardWidgetTypes = function (wizardParams: any, isCompare?: boolean, newKey?: any) {
    const compare =
        isCompare !== undefined
            ? isCompare
            : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;

    const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;

    const graphType =
        wizardParams.widget?.family === "Website" ? "EngagedVisitsSupportGraph" : "IndustryEngagementVisitsGraph";

    if (compare) {
        if (periodOverPeriod) {
            return ["TrafficGrowthComparison"];
        }
        return [graphType, "PieChart", "Table"];
    } else {
        if (periodOverPeriod) {
            return ["ComparedBar", "ComparedLine", "PeriodOverPeriodVisits"];
        }

        return [graphType, "PieChart", "SingleMetric"];
    }
};

export const EngagementAvgVisitDuration = {
    id: "EngagementAvgVisitDuration",
    properties: {
        dashboard: "true",
        apiController: "TrafficAndEngagement",
        title: "metric.engagementAvgVisitDuration.title",
        hasWebSource: true,
        family: "Website",
        component: "WebAnalysis",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_website_trafficandengagement",
        availabilityComponent: "WsWebTrafficAndEngagement",
        modules: {
            Industry: {
                dashboard: "true",
                family: "Industry",
                state: V2_ROUTES.overview,
                titleState: V2_ROUTES.overview,
                title: "metric.engagementAvgVisitDuration.title",
                apiController: "IndustryAnalysisOverview",
                component: "IndustryAnalysisOverview",
                availabilityComponent: "WsWebCategoryPerformance",
            },
        },
    },
    widgets: {
        single: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            SingleMetric: {
                properties: {
                    width: "4",
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                objects: {
                    AvgVisitDuration: {
                        name: "AvgVisitDuration",
                        title: "Avg. Visit Duration",
                        type: "double",
                        format: "time",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            ComparedBar: {
                properties: {
                    hasWebSource: true,
                    width: "4",
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
    getDashboardWidgetTypes: function (wizardParams: any, isCompare?: boolean) {
        const compare =
            isCompare !== undefined
                ? isCompare
                : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;
        const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;
        const graphType = wizardParams.widget?.family === "Website" ? "EngagedVisitsSupportGraph" : "Graph";
        if (compare) {
            return [graphType];
        } else {
            if (periodOverPeriod) {
                return ["ComparedBar", "ComparedLine"];
            } else {
                return [graphType, "SingleMetric"];
            }
        }
    },
};

export const EngagementBounceRate = {
    id: "EngagementBounceRate",
    properties: {
        dashboard: "true",
        apiController: "TrafficAndEngagement",
        hasWebSource: true,
        title: "metric.engagementBounceRate.title",
        family: "Website",
        component: "WebAnalysis",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        availabilityComponent: "WsWebTrafficAndEngagement",
        modules: {
            Industry: {
                dashboard: "true",
                family: "Industry",
                state: V2_ROUTES.overview,
                titleState: V2_ROUTES.overview,
                apiController: "IndustryAnalysisOverview",
                component: "IndustryAnalysisOverview",
                availabilityComponent: "WsWebCategoryPerformance",
            },
        },
    },
    widgets: {
        single: {
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                ppt: {
                    minValue: 0,
                    maxValue: 1,
                },
            },
            SingleMetric: {
                properties: {
                    width: "4",
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                objects: {
                    BounceRate: {
                        name: "BounceRate",
                        title: "Bounce Rate",
                        type: "double",
                        format: "change",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change-inverted",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "percentagesign",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            ComparedBar: {
                properties: {
                    hasWebSource: true,
                    width: "4",
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                    periodOverPeriodSupport: true,
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "change",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                ppt: {
                    minValue: 0,
                    maxValue: 1,
                },
            },
        },
    },
    getDashboardWidgetTypes: function (wizardParams: any, isCompare?: boolean) {
        const compare =
            isCompare !== undefined
                ? isCompare
                : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;
        const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;
        if (compare) {
            return ["Graph"];
        } else {
            if (periodOverPeriod) {
                return ["ComparedBar", "ComparedLine"];
            } else {
                return ["Graph", "SingleMetric"];
            }
        }
    },
};

export const EngagementDesktopVsMobileVisits = {
    id: "EngagementDesktopVsMobileVisits",
    properties: {
        dashboard: "true",
        apiController: "WebsiteOverview",
        title: "metric.engagementDesktopVsMobileVisits.title",
        family: "Website",
        component: "WebAnalysis",
        hasWebSource: true,
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        viewPermissions: {
            trafficSources: ["Total"],
        },
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
    },
    widgets: {
        single: {
            PieChart: {
                properties: {
                    hasWebSource: false,
                    options: {
                        twoColorMode: true,
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                objects: {
                    Desktop: {
                        name: "Desktop",
                        title: "Desktop",
                        type: "double",
                        format: "None",
                        cellTemp: "",
                    },
                    MobileWeb: {
                        name: "MobileWeb",
                        title: "Mobile",
                        type: "double",
                        format: "None",
                        cellTemp: "150px",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            Table: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "DesktopMobileShareVisits",
                        title: "Desktop                    Mobile",
                        type: "double[]",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "percentage-bar-cell-rounded",
                        headTemp: "desktop-mobile-header-cell",
                        headerCellClass: "u-no-pointer-events",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            overrideFormat: "smallNumbersPercentage:2",
                            overrideName: "Desktop Vs. Mobile",
                        },
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            DesktopVSMobile: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 20,
                    },
                },
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "DesktopMobileShareVisits",
                        title: "Desktop                    Mobile",
                        type: "double[]",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "percentage-bar-cell-rounded",
                        headTemp: "desktop-mobile-header-cell",
                        headerCellClass: "u-no-pointer-events",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            overrideFormat: "smallNumbersPercentage:2",
                            overrideName: "Desktop Vs. Mobile",
                        },
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
};

export const EngagementDesktopVsMobileVisitsSI = {
    ...EngagementDesktopVsMobileVisits,
    properties: {
        ...EngagementDesktopVsMobileVisits.properties,
        dashboard: "false",
        state: "accountreview_website_overview_websiteperformance",
    },
};

export const EngagementOverview = {
    id: "EngagementOverview",
    properties: {
        apiController: "TrafficAndEngagement",
        title: "metric.engagementOverview.title",
        family: "Website",
        hasWebSource: true,
        component: "WebAnalysis",
        mobileWebComponent: "WebAnalysis",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
        titleState: "digitalsuite_website_trafficandengagement",
        dashboard: "true",
        availabilityComponent: "WsWebTrafficAndEngagement",
    },
    widgets: {
        single: {
            defaultType: "EngagementTableDashboard",
            EngagementTableDashboard: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                columns: [
                    {
                        name: "Source",
                        title: "Source",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "default-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgMonthVisits",
                        title: "Avg. Monthly Visits",
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "UniqueUsers",
                        title: "wa.ao.graph.uv",
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        hideFrom28Days: true,
                    },
                    {
                        name: "VisitsPerUser",
                        title: "wa.ao.graph.vpu",
                        type: "double",
                        format: "number:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        hideFrom28Days: true,
                    },
                    {
                        name: "AvgVisitDuration",
                        title: "Avg. Visit Duration",
                        type: "double",
                        format: "time",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            overrideFormat: "time",
                        },
                    },
                    {
                        name: "PagesPerVisit",
                        title: "Pages/Visit",
                        type: "double",
                        format: "number:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "BounceRate",
                        title: "Bounce Rate",
                        type: "double",
                        format: "percentagesign:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellComponent: DefaultCellRightAlign,
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "EngagementTableDashboard",
            EngagementTableDashboard: {
                properties: {
                    options: {
                        showLegend: false,
                        preserveLegendSpace: true,
                    },
                    apiParams: {
                        includeLeaders: true,
                    },
                },
                columns: [
                    {
                        name: "Domain",
                        title: "wa.ao.engagement.domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgMonthVisits",
                        title: {
                            snapshot: "wa.ao.graph.avgvisits",
                            window: "wa.ao.graph.avgvisitsdaily",
                        },
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIcon: "widget-tab-visits",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                    {
                        name: "UniqueUsers",
                        title: "wa.ao.graph.uv",
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIcon: "widget-tab-visits",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        hideFrom28Days: true,
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                    {
                        name: "VisitsPerUser",
                        title: "wa.ao.graph.vpu",
                        type: "double",
                        format: "number:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIcon: "widget-tab-visits",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        hideFrom28Days: true,
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                    {
                        name: "AvgVisitDuration",
                        title: "wa.ao.graph.avgduration",
                        type: "double",
                        format: "time",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIcon: "widget-tab-duration",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                    {
                        name: "PagesPerVisit",
                        title: "wa.ao.engagement.pagesvisit",
                        type: "double",
                        format: "number:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIconName: "pager-per-visit",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                    {
                        name: "BounceRate",
                        title: "wa.ao.graph.bounce",
                        type: "double",
                        format: "percentagesign:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellTemp: "leader-default-cell",
                        headTemp: "leader-default-header-cell",
                        headerCellIconName: "bounce-rate-2",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            // Highlight a row's cell in case "IsLeader" property
                            // evaluates to true
                            highlightCellWhenPropsTrue: ["IsLeader"],
                            // Do not render IsLeader property value into the ppt table
                            ignoreCellProps: ["IsLeader", "IsLowest", "IsHighest"],
                        },
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
};

export const EngagementPagesPerVisit = {
    id: "EngagementPagesPerVisit",
    properties: {
        dashboard: "true",
        hasWebSource: true,
        apiController: "TrafficAndEngagement",
        title: "metric.engagementPagesPerVisit.title",
        family: "Website",
        component: "WebAnalysis",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        availabilityComponent: "WsWebTrafficAndEngagement",
        modules: {
            Industry: {
                dashboard: "true",
                family: "Industry",
                state: V2_ROUTES.overview,
                titleState: V2_ROUTES.overview,
                apiController: "IndustryAnalysisOverview",
                component: "IndustryAnalysisOverview",
                availabilityComponent: "WsWebCategoryPerformance",
            },
        },
    },
    widgets: {
        single: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    width: 2,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "decimalNumber",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    width: 2,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "decimalNumber",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            SingleMetric: {
                properties: {
                    width: "4",
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                objects: {
                    PagesPerVisit: {
                        name: "PagesPerVisit",
                        title: "Pages / Visits",
                        type: "double",
                        format: "decimalNumber",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            ComparedBar: {
                properties: {
                    hasWebSource: true,
                    width: "4",
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "decimalNumber",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "time",
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    width: 2,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "decimalNumber",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    width: 2,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "decimalNumber",
                    formatParameter: 2,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
    getDashboardWidgetTypes: function (wizardParams: any, isCompare?: boolean) {
        const compare =
            isCompare !== undefined
                ? isCompare
                : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;
        const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;
        const graphType = wizardParams.widget?.family === "Website" ? "EngagedVisitsSupportGraph" : "Graph";
        if (compare) {
            return [graphType];
        } else {
            if (periodOverPeriod) {
                return ["ComparedBar", "ComparedLine"];
            } else {
                return [graphType, "SingleMetric"];
            }
        }
    },
};

export const EngagementTotalPagesViews = {
    id: "EngagementTotalPagesViews",
    properties: {
        dashboard: "true",
        hasWebSource: true,
        apiController: "TrafficAndEngagement",
        title: "wa.ao.graph.PageViews",
        family: "Website",
        component: "WebAnalysis",
        order: "1",
        state: "websites.worldwideOverview",
        availabilityComponent: "WsWebTrafficAndEngagement",
    },
    widgets: {
        single: {
            defaultType: "EngagedVisitsSupportGraph",
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Page Views",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "PageViews",
                    reversed: "False",
                },
                filters: {},
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Page Views",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "PageViews",
                    reversed: "False",
                },
            },
        },
        compare: {
            defaultType: "EngagedVisitsSupportGraph",
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Page Views",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "PageViews",
                    reversed: "False",
                },
                filters: {},
            },
        },
    },
    getDashboardWidgetTypes: function (wizardParams: any, isCompare?: boolean) {
        const compare =
            isCompare !== undefined
                ? isCompare
                : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;
        const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;
        if (compare) {
            return ["EngagedVisitsSupportGraph"];
        } else {
            if (periodOverPeriod) {
                return ["ComparedLine"];
            } else {
                return ["EngagedVisitsSupportGraph"];
            }
        }
    },
};

const deviceDistributionPieChart = {
    properties: {
        hasWebSource: false,
        options: {
            twoColorMode: true,
            showLegend: false,
            dashboardSubtitleMarginBottom: 15,
        },
        modules: {
            Industry: {
                title: "wa.ao.trafficshare",
            },
        },
    },
    objects: {
        Desktop: {
            name: "Desktop",
            title: "Desktop",
            type: "double",
            format: "None",
            cellTemp: "",
        },
        MobileWeb: {
            name: "MobileWeb",
            title: "Mobile",
            type: "double",
            format: "None",
            cellTemp: "",
        },
    },
    filters: {
        ShouldGetVerifiedData: [
            {
                value: "true",
                title: "Yes",
            },
            {
                value: "false",
                title: "No",
            },
        ],
    },
};

// Used in app/pages/industry-analysis/overview/components/DeviceDistributionChart/components/DeviceDistributionChartTitle/DeviceDistributionChartTitle.tsx
// Shown as unused because re-exported from all-metrics as unnamed default export
// and is used as a string key instead of import
export const IndustryDeviceDistribution = {
    id: "IndustryDeviceDistribution",
    properties: {
        hasWebSource: true,
        endpoint: "widgetApi/IndustryAnalysisOverview/EngagementVisits",
        title: "metric.engagementVisits.title",
        order: "1",
        periodOverPeriodSupport: true,
        useCombinedInsteadOfTotal: true,
        family: "Industry",
        state: V2_ROUTES.overview,
        titleState: V2_ROUTES.overview,
        dashboard: "true",
        component: "IndustryAnalysisOverview",
        availabilityComponent: "WsWebCategoryPerformance",
        modules: {
            Industry: { hasWebSource: false },
        },
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
    },
    widgets: {
        single: {
            PieChart: deviceDistributionPieChart,
        },
    },
};

export const EngagementVisits = {
    id: "EngagementVisits",
    properties: {
        dashboard: "true",
        hasWebSource: true,
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL, devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        apiController: (keys, { type }) =>
            type === "TrafficGrowthComparison" ? "TrafficGrowthComparison" : "TrafficAndEngagement",
        title: "metric.engagementVisits.title",
        family: "Website",
        component: "TrafficAndEngagement",
        mobileWebComponent: "TrafficAndEngagement",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_website_trafficandengagement",
        periodOverPeriodSupport: true,
        useCombinedInsteadOfTotal: true,
        modules: {
            Industry: {
                family: "Industry",
                state: V2_ROUTES.overview,
                titleState: V2_ROUTES.overview,
                apiController: "IndustryAnalysisOverview",
                dashboard: "true",
                component: "IndustryAnalysisOverview",
                availabilityComponent: "WsWebCategoryPerformance",
            },
        },
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
        availabilityComponent: "WsWebTrafficAndEngagement",
    },
    widgets: {
        single: {
            defaultType: "IndustryEngagementVisitsGraph",
            IndustryEngagementVisitsGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
            EngagementVisitsGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                    modules: {
                        Industry: {
                            title: "wa.ao.totalvisits",
                        },
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            PieChart: deviceDistributionPieChart,
            SingleMetric: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                    modules: {
                        Industry: {
                            title: "wa.ao.totalvisits",
                        },
                    },
                },
                objects: {
                    TotalVisits: {
                        name: "TotalVisits",
                        share: "ShareOfVisits",
                        title: "Total Visits",
                        type: "number",
                        format: "abbrNumberVisits",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            ComparedBar: {
                properties: {
                    hasWebSource: true,
                    width: "4",
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            PeriodOverPeriodVisits: {
                properties: {
                    hasWebSource: true,
                    options: {
                        template: "/app/components/single-metric/single-metric-website-overview-change-pop.html",
                        showSubtitle: false,
                        showLegend: false,
                        hideDurationFromSubtitle: true,
                    },
                    periodOverPeriodSupport: true,
                },
                objects: {
                    TotalVisits: {
                        name: "TotalVisits",
                        share: "ShareOfVisits",
                        title: "Total Visits",
                        type: "double",
                        format: "abbrNumber",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            PieChart: {
                properties: {
                    options: {
                        showLegend: false,
                        preserveLegendSpace: true,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                objects: {
                    TotalVisits: {
                        name: "TotalVisits",
                        title: "Total Visits",
                        type: "double",
                        format: "None",
                        cellTemp: "",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            Table: {
                properties: {
                    width: "2",
                    options: {
                        showLegend: false,
                        preserveLegendSpace: true,
                    },
                },
                columns: [
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "TotalVisits",
                        title: "Total Visits",
                        type: "double",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "number-comma-cell",
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            overrideFormat: "abbrNumber",
                        },
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            TrafficGrowthComparison: {
                properties: {
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
    getDashboardWidgetTypes,
};

// we don't want the modules property copied, otherwise it will appear twice in the Add a Metric page (ie. 2 metric cards)
const engagementVisitsClone = cloneDeep(EngagementVisits);
delete engagementVisitsClone.properties.modules;
export const EngagementVisitsSI = {
    ...engagementVisitsClone,
    properties: {
        ...engagementVisitsClone.properties,
        dashboard: "false",
        state: "accountreview_website_overview_websiteperformance",
    },
};

export const EngagementOverviewUniques = {
    id: "EngagementOverviewUniques",
    serverId: "EngagementOverview",
    properties: {
        family: "Website",
        title: "",
        addToDashboardMetric: "EngagementOverview",
        hasWebSource: true,
        component: "WebAnalysis",
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
    },
    widgets: {
        single: {
            Table: {
                properties: {
                    options: {
                        showLegend: false,
                    },
                },
                columns: [
                    {
                        name: "Source",
                        title: "Source",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "default-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgMonthVisits",
                        title: "Avg. Monthly Visits",
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "number-comma-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgVisitDuration",
                        title: "Avg. Visit Duration",
                        type: "double",
                        format: "number",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "time-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                        ppt: {
                            overrideFormat: "time",
                        },
                    },
                    {
                        name: "PagesPerVisit",
                        title: "Pages/Visit",
                        type: "double",
                        format: "number",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "number-twodecimals-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "BounceRate",
                        title: "Bounce Rate",
                        type: "double",
                        format: "percentagesign:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellTemp: "default-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            Table: {
                properties: {
                    options: {
                        showLegend: false,
                        preserveLegendSpace: true,
                    },
                },
                columns: [
                    {
                        name: "Domain",
                        title: "wa.ao.engagement.domain",
                        type: "string",
                        format: "None",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "True",
                        cellTemp: "website-tooltip-top-cell",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgMonthVisits",
                        title: {
                            snapshot: "wa.ao.graph.avgvisits",
                            window: "wa.ao.graph.avgvisitsdaily",
                        },
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "UniqueUsers",
                        title: "wa.ao.graph.uv",
                        type: "double",
                        format: "minVisitsAbbr",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "VisitsPerUser",
                        title: "wa.ao.graph.vpu",
                        type: "double",
                        format: "number",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "number-twodecimals-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "AvgVisitDuration",
                        title: "wa.ao.graph.avgduration",
                        type: "double",
                        format: "number",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "time-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "PagesPerVisit",
                        title: "wa.ao.engagement.pagesvisit",
                        type: "double",
                        format: "number",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "number-twodecimals-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                    {
                        name: "BounceRate",
                        title: "wa.ao.graph.bounce",
                        type: "double",
                        format: "percentagesign:2",
                        sortable: "False",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellTemp: "default-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "",
                        width: "",
                    },
                ],
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
};

export const AudienceInterests = {
    id: "AudienceInterests",
    properties: {
        dashboard: "true",
        title: "dashboard.metrics.titles.audience.interests",
        family: "Website",
        component: "WebAnalysis",
        hasWebSource: true,
        order: "1",
        state: "digitalsuite_website_audienceInterests",
        apiController: "AudienceInterests",
        noCompare: true,
        availabilityComponent: "WebAudienceInterests",
        stateParams: {
            selectedTab: ECategoryAudienceType.AudienceInterests,
        },
    },
    widgets: {
        single: {
            defaultType: "AudienceInterestsTable",
            AudienceInterestsTable: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                filters: {
                    orderBy: [
                        {
                            value: "RelevancyScore desc",
                            title: "RelevancyScore",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "AudienceInterestsTable",
            AudienceInterestsTable: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        desktopOnly: true,
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                filters: {
                    orderBy: [
                        {
                            value: "RelevancyScore desc",
                            title: "RelevancyScore",
                        },
                    ],
                },
            },
        },
    },
};

export const EngagementDedup = {
    id: "EngagementDedup",
    properties: {
        component: "UniqueVisitors",
        state: "digitalsuite_website_trafficandengagement",
        hasWebSource: false,
        title: "metric.uniquevisitors.title",
        family: "Website",
        order: "1",
        apiController: "TrafficAndEngagement",
    },
    widgets: {
        single: {
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    width: 2,
                    options: {
                        showLegend: false,
                        widgetColors: "forceSetupColors",
                    },
                    defaultTimeGranularity: "Monthly",
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Unique Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Unique Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    defaultTimeGranularity: "Monthly",
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Unique Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Unique Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
};

export const EngagementUniqueUsers = {
    id: ENGAGEMENT_UNIQUE_USERS,
    properties: {
        dashboard: "true",
        hasWebSource: true,
        noCompare: true,
        apiController: (keys, { type }) => {
            return type === "TrafficGrowthComparison" ? "TrafficGrowthComparison" : "TrafficAndEngagement";
        },
        title: "dashboard.metricGallery.Industry.EngagementUniqueUsers.title",
        family: "Industry",
        component: "TrafficAndEngagement",
        order: "1",
        state: "digitalsuite_website_websiteperformance",
        titleState: "digitalsuite_website_trafficandengagement",
        periodOverPeriodSupport: true,
        trafficSources: ["MobileWeb", "Desktop", "Total"],
        useCombinedInsteadOfTotal: true,
        apiParams: {
            metric: ENGAGEMENT_UNIQUE_USERS,
        },
        modules: {
            Industry: {
                family: "Industry",
                state: V2_ROUTES.overview,
                titleState: V2_ROUTES.overview,
                apiController: "IndustryAnalysisOverview",
                dashboard: "false",
                component: "IndustryAnalysisOverview",
                availabilityComponent: "WsWebCategoryPerformance",
            },
        },
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
        availabilityComponent: "WsWebTrafficAndEngagement",
    },
    widgets: {
        single: {
            EngagedVisitsSupportGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                    },
                    modules: {
                        Industry: {
                            title: "dashboard.metricGallery.Industry.EngagementUniqueUsers.inner.title",
                        },
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
            },
            PieChart: deviceDistributionPieChart,
            ComparedBar: {
                properties: {
                    hasWebSource: true,
                    width: "4",
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
            },
            ComparedLine: {
                properties: {
                    hideMarkersOnDaily: true,
                    periodOverPeriodSupport: true,
                    options: {
                        showLegend: false,
                        mobileWebAlgoChangeDate: true,
                        dashboardSubtitleClass: "period-over-period-dashboard-subtitle",
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: "False",
                },
                filters: {},
            },
            PeriodOverPeriodVisits: {
                properties: {
                    hasWebSource: true,
                    options: {
                        template: "/app/components/single-metric/single-metric-website-overview-change-pop.html",
                        showSubtitle: false,
                        showLegend: false,
                        hideDurationFromSubtitle: true,
                    },
                    periodOverPeriodSupport: true,
                },
                objects: {
                    TotalVisits: {
                        name: "TotalVisits",
                        share: "ShareOfVisits",
                        title: "Total Visits",
                        type: "double",
                        format: "abbrNumber",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
            },
        },
    },
    getDashboardWidgetTypes: function (wizardParams: any, isCompare?: boolean) {
        const compare =
            isCompare !== undefined
                ? isCompare
                : _.isArray(wizardParams.competitorList) && wizardParams.competitorList.length > 0;

        const periodOverPeriod = wizardParams.comparedDurationSelectedItem || wizardParams.widget.comparedDuration;

        const graphType = wizardParams.widget?.family === "Website" ? "EngagedVisitsSupportGraph" : "Graph";

        if (compare) {
            if (periodOverPeriod) {
                return ["TrafficGrowthComparison"];
            }
            return [graphType, "Table"];
        } else {
            if (periodOverPeriod) {
                return ["ComparedLine"];
            }
            return [graphType];
        }
    },
};

export const UniqueUsers = {
    id: "UniqueUsers",
    properties: {
        component: "UniqueVisitors",
        state: "digitalsuite_website_trafficandengagement",
        dashboard: "true",
        useCombinedInsteadOfTotal: true,
        hasWebSource: true,
        title: "metric.uniquevisitors.title",
        family: "Website",
        order: "1",
        apiController: "UniqueUsers",
        customFetcherFactory: {
            path: "common.showGAApprovedData",
            factoryName: "ConnectedAssetsDataFetcherFactory",
        },
        availabilityComponent: "WsWebTrafficAndEngagement",
    },
    widgets: {
        single: {
            UniqueVisitors: {
                properties: {
                    width: "4",
                    headTemp: "unique-visitors-header",
                },
                objects: {
                    TotalVisits: {
                        name: "AverageTotalVisitsMonthly",
                        title: "wa.ao.graph.avgvisits",
                        type: "double",
                        format: "minVisitsAbbr",
                        cellTemp: "unique-visitors-row",
                    },
                    UniqueUsers: {
                        name: "AverageUniqueVisitorsMonthly",
                        title: "metric.monthlyuniquevisitors",
                        type: "double",
                        format: "minVisitsAbbr",
                        titleFormat: "roundNumber",
                        cellTemp: "unique-visitors-row-unsupported-date",
                        isBeta: true,
                    },
                    VisitsPerUser: {
                        name: "VisitsPerUser",
                        title: "metric.visitsperuser",
                        type: "double",
                        format: "number:2",
                        titleFormat: "number",
                        cellTemp: "unique-visitors-row-unsupported-date",
                        isBeta: true,
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    stacked: true,
                    width: 2,
                    options: {
                        showLegend: false,
                    },
                    defaultTimeGranularity: "Monthly",
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Unique Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Unique Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
            SingleMetric: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                    modules: {
                        Industry: {
                            title: "wa.ao.totalvisits",
                        },
                    },
                },
                objects: {
                    TotalVisits: {
                        name: "AverageUniqueVisitorsMonthly",
                        title: "Monthly Unique Visitors",
                        type: "number",
                        format: "abbrNumberVisits",
                        cellTemp: "large-number",
                    },
                    Change: {
                        name: "Change",
                        title: "Monthly Change",
                        type: "int?",
                        format: "change",
                        cellTemp: "change",
                    },
                    Trend: {
                        name: "Trend",
                        title: "Trend",
                        type: "long[]",
                        format: "None",
                        cellTemp: "trend-line",
                    },
                },
                filters: {
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
        compare: {
            Graph: {
                properties: {
                    hideMarkersOnDaily: true,
                    defaultTimeGranularity: "Monthly",
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Unique Visits",
                    type: "long",
                    format: "minVisitsAbbr",
                    formatParameter: 0,
                    name: "Unique Visits",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                    ],
                    ShouldGetVerifiedData: [
                        {
                            value: "true",
                            title: "Yes",
                        },
                        {
                            value: "false",
                            title: "No",
                        },
                    ],
                },
            },
        },
    },
};
